module.exports = __webpack_public_path__ + "static/img/habenleumi.b046a28.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bank-logos/habenleumi.jpg
// module id = KdQj
// module chunks = 6